import { MatDateFormats, NativeDateAdapter } from "@angular/material/core";

export const FECHA_ESTANDAR_FORMATS: MatDateFormats = {
  parse: {
    dateInput: "dd/MM/yyyy",
  },
  display: {
    dateInput: "dd/MM/yyyy",
    monthYearLabel: { month: "short", year: "numeric" },
    dateA11yLabel: { day: "2-digit", month: "long", year: "numeric" },
    monthYearA11yLabel: { month: "long", year: "numeric" },
  },
};

export class FechaEstandarAdapter extends NativeDateAdapter {
  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value === "string") {
      const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value.trim());
      if (match) {
        const day = Number(match[1]);
        const month = Number(match[2]) - 1;
        const year = Number(match[3]);
        const date = new Date(year, month, day);

        return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day
          ? date
          : null;
      }
    }

    return super.parse(value as any, parseFormat as any);
  }

  override format(date: Date, displayFormat?: unknown): string {
    if (!this.isValid(date)) {
      return "";
    }

    if (displayFormat === FECHA_ESTANDAR_FORMATS.display.dateInput) {
      return [
        String(date.getDate()).padStart(2, "0"),
        String(date.getMonth() + 1).padStart(2, "0"),
        date.getFullYear(),
      ].join("/");
    }

    return super.format(date, displayFormat ?? FECHA_ESTANDAR_FORMATS.display.dateInput);
  }
}
